import { render } from "./AnnouncementForm.vue?vue&type=template&id=603e33e9&scoped=true&ts=true"
import script from "./AnnouncementForm.ts?vue&type=script&lang=ts"
export * from "./AnnouncementForm.ts?vue&type=script&lang=ts"

import "./AnnouncementForm.scss?vue&type=style&index=0&id=603e33e9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603e33e9"]])

export default __exports__